"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var KsysRequest_1 = require("../KsysRequest");
var GetApplicationClientConfiguration = /** @class */ (function (_super) {
    __extends(GetApplicationClientConfiguration, _super);
    function GetApplicationClientConfiguration() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getExplicitEndpoint = function () { return '/applicationManager/getApplicationClientConfiguration'; };
        _this.getExplicitMethod = function () { return 'GET'; };
        return _this;
    }
    Object.defineProperty(GetApplicationClientConfiguration.prototype, "endpointConfiguration", {
        get: function () {
            return this.getEndpointConfiguration("applicationManager", "GetApplicationClientConfiguration");
        },
        enumerable: true,
        configurable: true
    });
    return GetApplicationClientConfiguration;
}(KsysRequest_1.KsysRequest));
exports.GetApplicationClientConfiguration = GetApplicationClientConfiguration;
//# sourceMappingURL=GetApplicationClientConfiguration.js.map